import {
  TextField,
  Typography,
  Box,
  MenuItem,
  Button,
  IconButton,
  DialogActions,
  DialogTitle,
  DialogContent,
  useMediaQuery,
  Card,
  Paper,
  Fab,
  ListItem,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddProductModal from "../AddProductModal";
// import { panelSystem as panelOptions } from "../../../../../../catalog";
import { useState, useContext, useEffect } from "react";
import { MobileOrderContext } from "../../../../../../context/MobileOrderContext";
import { useTheme } from "@emotion/react";
import TextFieldDebounced from "../../../../../../components/TextFieldDebounced";

const Coil = ({
  showSaving,
  isUpdating,
  isProductSelected,
  isAutoSaving,
  canUpdate,
  open,
  handleClose,
  handleNext,
  hasNext,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const { coil, coilDispatch, orderDispatch } = useContext(MobileOrderContext);

  const addOrderItem = (item) => {
    orderDispatch({ type: "add order item", payload: item });
  };

  useEffect(() => {
    if (isProductSelected && canUpdate && isAutoSaving) {
      // TODO: auto save on every change
      addOrderItem(coil);
    }
  }, [isProductSelected, coil]);

  return (
    <>
      <AddProductModal
        showSaving={showSaving}
        isUpdating={isUpdating}
        open={open}
        handleClose={() => {
          addOrderItem(coil);
          handleClose();
        }}
      >
        <DialogTitle>Coil</DialogTitle>
        <DialogContent
          sx={{
            gap: "1rem",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row", marginTop: "8px" }}>
            <TextFieldDebounced
              disabled={!canUpdate}
              sx={{}}
              onFocus={(e) => e.target.select()}
              type="number"
              onWheel={(event) => {
                event.preventDefault();
              }}
              size="small"
              label="Lineal Feet"
              value={coil.linealFeet}
              onChange={(e) => {
                coilDispatch({
                  type: "linealFeet",
                  payload: e.target.value
                    ? parseFloat(e.target.value)
                    : e.target.value,
                });
              }}
            />
            <TextFieldDebounced
              disabled={!canUpdate}
              sx={{ marginLeft: "8px" }}
              onFocus={(e) => e.target.select()}
              type="number"
              onWheel={(event) => {
                event.preventDefault();
              }}
              size="small"
              label="Width (in.)"
              value={coil.width}
              onChange={(e) => {
                coilDispatch({
                  type: "width",
                  payload: e.target.value
                    ? parseFloat(e.target.value)
                    : e.target.value,
                });
              }}
            />
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              addOrderItem(coil);
              handleClose();
            }}
          >
            {/* {canUpdate && isAutoSaving ? "Save & Close" : "Close"} */}
            Close
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              addOrderItem(coil);
              handleNext();
            }}
          >
            {hasNext
              ? "Next"
              : canUpdate && isAutoSaving
              ? "Save & Exit"
              : "Exit"}
          </Button>
        </DialogActions>
      </AddProductModal>
    </>
  );
};
export default Coil;
